import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from '../../redux/actions';
import { useTranslation } from 'react-i18next';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import { getUserInfo } from '../../api/userService';
import { getTokenLogin } from '../../api/tokenService';
import { repackOrganizationId } from '../../config';

import { useHistory } from 'react-router-dom';
import { loginErrorHandler } from './LoginErrorHandler';
import styles from './Login.module.css';
import { getAllOrganizations } from '../../api/organizationService';
import { getModuleTemplates } from '../../api/moduleService';

export default function LoginForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [emailInput, setUserNameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [errorRequest, setErrorRequest] = useState('');

  const loginSuccessHandler = (username) => {
    dispatch(getAllOrganizations());
    dispatch(getModuleTemplates());
    getUserInfo(username)
      .then((res) => {
        dispatch(userActions.setLoggedInUser(res.userName));
        dispatch(userActions.setUserOrganization(res.organizationId));
        if (res.organizationId === repackOrganizationId) {
          dispatch(userActions.setUserRepack(true));
        }
        return res.organizationId;
      })
      .then(() => {
        history.push('/systems');
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const postLogin = (e) => {
    e.preventDefault();
    getTokenLogin(emailInput, passwordInput)
      .then((data) => {
        if (data.access_token) {
          localStorage.setItem('token', data.access_token);
          localStorage.setItem('allowedSessionLength', data.expires_in);
          localStorage.setItem('timeOfLogin', new Date().toISOString());
          dispatch(userActions.logIn());
          loginSuccessHandler(emailInput);
        }
      })
      .catch((error) => {
        if (error.response) {
          loginErrorHandler(error.response, setErrorRequest);
        }
      });

    setUserNameInput('');
    setPasswordInput('');
  };

  const handleEmailChange = (e) => {
    setUserNameInput(e.target.value);
  };

  const handlePasswordInputChange = (e) => {
    setPasswordInput(e.target.value);
  };

  return (
    <div>
      <p className={styles.errorText}>{errorRequest}</p>
      <div className="form-div-login">
        <form onSubmit={postLogin} className="login-form" autoComplete="off">
          <FormControl required={true} variant="outlined">
            <InputLabel>Email</InputLabel>
            <OutlinedInput
              type={'email'}
              value={emailInput}
              onChange={handleEmailChange}
              label="Email"
              className={styles.inputField}
            />
          </FormControl>
          <FormControl required={true} variant="outlined">
            <InputLabel>Password</InputLabel>
            <OutlinedInput
              value={passwordInput}
              onChange={handlePasswordInputChange}
              label="password"
              type="password"
              className={styles.inputField}
            />
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            className={styles.loginButton}
          >
            {t('signIn')}
          </Button>
        </form>
      </div>
    </div>
  );
}
